import { Box, Link } from '@mui/material'
import { Outlet } from 'react-router-dom'
import './index.css'
import { useState, useEffect } from 'react'

const sx = {
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '15px 20px 15px 25px',
    gap: '218px',
    position: 'absolute',
    width: '100%',
    height: '55px',
    left: '0px',
    top: '0px',
  },
}

const AuthLayout = () => {
  const [width, setWindowWidth] = useState()
  const updateDimentions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
  }
  window.addEventListener('resize', updateDimentions)

  useEffect(() => {
    updateDimentions()

    window.addEventListener('resize', updateDimentions)
    return () => window.removeEventListener('resize', updateDimentions)
  }, [])

  const responsive = {
    showTopNavMenu: width > 1023,
  }

  // const navigate = useNavigate()
  return (
    <>
      {width > 1023 ? (
        <Box showTopNavMenu={responsive.showTopNavMenu} style={{ display: width > 1023 ? 'block' : 'none' }}>
          <Box display="flex">
            <Box className="authBackground">
              <Link href="https://markaaz.com">
                <img
                  style={{ cursor: 'pointer', position: 'absolute', zIndex: 9, margin: '25px 0 0 20px' }}
                  src="https://markaazwebobjects.app.markaaz.com/markaaz_logo_blue.043fce4d.png"
                  width={120}
                  alt="logo"
                  // onClick={() => navigate('/')}
                />
              </Link>
              <Box display="flex" height="100%" alignItems="center" justifyContent="center" flexDirection="column">
                <Box textAlign="center" fontWeight={600} fontSize="22px" color="#fff">
                  Unleash your business’s growth potential
                </Box>
                <Box textAlign="center" fontSize="16px" color="#fff" margin="20px">
                  Get all the services you need to manage your finances, assess your creditworthiness, get fast
                  financing, and easily apply for the services you need to grow.
                </Box>
              </Box>
            </Box>
            <Box width="62%" sx={{ background: '#F2F8FC' }}>
              <Outlet />
            </Box>
          </Box>
        </Box>
      ) : (
        <Box style={{ display: width <= 1024 ? 'flex' : 'none' }}>
          <Box sx={sx.header}>
            <Link href="https://markaaz.com">
              <img
                src="https://dashboard.app.markaaz.com/static/media/markaaz_logo_blue.043fce4d.png"
                width={90}
                alt="logo"
                // onClick={() => navigate('/auth')}
              />
            </Link>
          </Box>
          <Box sx={{ background: '#F2F8FC' }}>
            <Outlet />
          </Box>
        </Box>
      )}
    </>
  )
}

export default AuthLayout
